import { PageHeader, Card, Pill, Notice } from "@/dashboard/ui";
import TasksPanel from "@/dashboard/TasksPanel";
import { ArrowRight, Zap } from "lucide-react";

const AUTOMATIONS = [
  { trigger: "New lead added with a follow-up date", action: "Create a follow-up task", live: true },
  { trigger: "Lead requests a callback", action: "Create a callback task", live: false },
  { trigger: "Appointment booked", action: "Prepare a reminder", live: false },
  { trigger: "Lead becomes qualified", action: "Create a sales follow-up", live: false },
  { trigger: "Campaign completed", action: "Prepare a performance summary", live: false },
];

export default function Automations() {
  return (
    <div data-testid="automations-page">
      <PageHeader title="Automations" sub="Workflows that keep your follow-ups moving. External calls, emails and messages stay disabled until their integrations are ready." />

      <div className="space-y-3">
        {AUTOMATIONS.map((a, i) => (
          <Card key={i} className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center" data-testid={`automation-${i}`}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-neutral-100 text-[#111111]">
              <Zap size={17} />
            </span>
            <div className="flex flex-1 flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
              <p className="text-sm font-semibold text-[#111111]">{a.trigger}</p>
              <ArrowRight size={15} className="hidden shrink-0 text-neutral-300 sm:block" />
              <p className="text-sm text-neutral-500">{a.action}</p>
            </div>
            <Pill tone={a.live ? "black" : "outline"}>{a.live ? "Active — internal" : "Planned"}</Pill>
          </Card>
        ))}
      </div>

      <div className="mt-8">
        <Notice
          testid="automations-notice"
          title="What's actually running"
          body="Right now only the internal CRM workflow is live: adding a lead with a follow-up date automatically creates the task below. Everything else activates once email, SMS and calling integrations connect."
        />
      </div>

      <h2 className="mb-3 mt-8 text-lg font-bold text-[#111111]">Follow-up tasks</h2>
      <TasksPanel />
    </div>
  );
}
